var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup292(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 134.765,
    height: 50.222,
    viewBox: "0 0 134.765 50.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#748d6f}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    transform: "translate(-55.235 -78.778)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Manajemen_Operasional",
    fill: "#748d6f",
    fontFamily: "Belleza-Regular, Belleza",
    fontSize: "16px",
    transform: "translate(114 106)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Manajemen"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19
  }, "Operasional")), /*#__PURE__*/React.createElement("g", {
    id: "PT_Avoskin_innovation_and_technology",
    transform: "translate(55 78.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    d: "M195.58 318.941c-.619-.142-1.235-.278-1.854-.424a16.836 16.836 0 0 1 1.194-32.987 17.358 17.358 0 0 1 7.571.481c.16-.894.284-1.773.471-2.624a13.991 13.991 0 0 1 6.446-9.49c2.585-1.576 5.189-3.107 7.784-4.661a1.7 1.7 0 0 0 .256-.236h.148a15.223 15.223 0 0 0-1.084 7.405l7.995-2.033c-1.842 3.2-2.851 5.607-2.711 6.907.749 0 1.509-.037 2.266 0 2.084.122 4.167.28 6.249.422v.3a5.567 5.567 0 0 0-.816.437 16.948 16.948 0 0 0-4.864 6.3 42.949 42.949 0 0 1-2.7 4.811 7.256 7.256 0 0 1-5.122 3.4c-.985.148-1.937.445-2.931.68.059.266.095.431.132.591A16.807 16.807 0 0 1 203.287 318c-1.194.428-2.467.636-3.7.946zm-13.544-16.777a15.58 15.58 0 1 0 15.516-15.609 15.636 15.636 0 0 0-15.516 15.609z",
    className: "cls-2",
    transform: "translate(-180.582 -269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    d: "M289.963 413.242a5.349 5.349 0 1 1-1.514-3.807 5.376 5.376 0 0 1 1.514 3.807zm-5.363 4.637a4.635 4.635 0 1 0-3.3-1.335 4.647 4.647 0 0 0 3.3 1.335z",
    className: "cls-2",
    transform: "translate(-259.591 -380.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    d: "M204.968 408l5.3 10.185c-.569.268-.758-.093-.959-.471q-1.931-3.611-3.873-7.218c-.124-.229-.262-.447-.445-.758-.183.317-.321.54-.441.77-1.273 2.415-2.561 4.829-3.8 7.256a.659.659 0 0 1-1.036.345z",
    className: "cls-2",
    transform: "translate(-195.753 -380.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    d: "M237.116 418.653l-5.266-10.132c.558-.23.837-.053 1.084.426 1.235 2.407 2.5 4.8 3.765 7.193.12.232.256.457.431.768.156-.256.274-.431.374-.617q2-3.7 3.981-7.411c.2-.357.378-.642.922-.408-1.743 3.355-3.481 6.702-5.291 10.181z",
    className: "cls-2",
    transform: "translate(-221.561 -380.927)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup292);
export default __webpack_public_path__ + "static/media/Group 292.5611e75271ee7ac5a1982d23f347b2cf.svg";
export { ForwardRef as ReactComponent };